import { useState } from 'react'

import { DateTimePicker } from '../../DateTime'
import { Component, ComponentProps } from '../Component'
import { boolean, controls, dateTime, text } from '../Controls'

import { DateTimeProviderProps } from './DateTimeProviderProps'

export function DateTimePickerUsage() {
  const [props, setProps] = useState(() =>
    controls() //
      .add(boolean('borderless', false))
      .add(boolean('clearable', true))
      .add(boolean('disabled', false))
      .add(text('errorText'))
      .add(text('label', 'Date / time picker'))
      .add(dateTime('maxValue', null))
      .add(dateTime('minValue', null))
      .add(text('separator'))
      .add(boolean('showError'))
      .add(dateTime('value', null))
  )

  function handleChange(nextValue) {
    setProps(currProps => currProps.setValue('value', nextValue))
  }

  return (
    <DateTimeProviderProps>
      <Component
        {...props.getValues()}
        Component={DateTimePicker}
        name='DateTimePicker'
        onChange={handleChange}
      />
      <ComponentProps name='DateTimePicker' value={props} onChange={setProps} />
    </DateTimeProviderProps>
  )
}
